import { render } from "./SubmitButton.vue?vue&type=template&id=d56b2bf8"
const script = {}

import exportComponent from "/Users/bertog/Code/aitmes/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__